import {
	matchPromotionTexts,
	toPromotionTexts,
	type PromotionText,
	type PromotionTextProduct
} from "~/utils/promotions/promotionTexts";

/** [GF-71] Promotion texts, loaded in `initApp` and shared via SSR payload. */
export const usePromotionTexts = () => {
	const { enabled = false } = useRuntimeConfig().public.promotionText ?? {};
	const { listPromotions } = useNorcePwa();
	const promotions = useState<PromotionText[]>(
		"norce-promotion-texts",
		() => []
	);

	const loadPromotionTexts = async (
		localeCode: string,
		cultureCode: string
	) => {
		if (!enabled) return;
		try {
			const catalogPromotions = await listPromotions({
				localeCode,
				cultureCode
			});
			promotions.value = toPromotionTexts(catalogPromotions, new Date());
		} catch (error) {
			console.warn(
				"[usePromotionTexts] listPromotions failed:",
				error instanceof Error ? error.message : error
			);
		}
	};

	const getPromotionTexts = (product?: PromotionTextProduct | null) =>
		enabled ? matchPromotionTexts(product, promotions.value) : [];

	return { loadPromotionTexts, getPromotionTexts };
};
